import { mapActions } from 'vuex';

export default {
  props: {
    isCompleted: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    await this.LOAD_userSignatures();
    // await this.loadUsers();
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('userSignatures', ['LOAD_userSignatures']),
    // ...mapActions('userManagement', ['loadUsers']),
  },
};
